import React, { useEffect } from "react";

export const ContextAuthentication = React.createContext(undefined);

export const ContextAuthProvider = ({ children }) => {
  const isSupperUser =
    localStorage.getItem("is_superuser") === "false" ? false : true;
  const isStaff = localStorage.getItem("is_staff") === "false" ? false : true;
  const keyUser = localStorage.getItem("key") ?? "";

  const isAdmin = isSupperUser && isStaff;

  const [value, setValue] = React.useState({ isAdmin: isAdmin, key: keyUser });

  useEffect(() => {
    setValueContext({ isAdmin, key: keyUser });
  }, [isAdmin]);

  const setValueContext = (obj) => {
    setValue((prev) => ({ ...prev, ...obj }));
  };

  return (
    <ContextAuthentication.Provider
      value={{ value, setValueContext }}
      children={children}
    />
  );
};

export const useContextAuthentication = () => {
  const contextValue = React.useContext(ContextAuthentication);
  if (!contextValue) {
    throw new Error("Tried to use template context from outside the provider");
  }
  return contextValue;
};